export enum TransactionGroup {
  AdminCredit = 'AdminCredit',
  AdminDebit = 'AdminDebit',
  BonusPurchased = 'BonusPurchased',
  CashBonus = 'CashBonus',
  Chargeback = 'Chargeback',
  ChargebackCorrection = 'ChargebackCorrection',
  Conversion = 'Conversion',
  Correction = 'Correction',
  Deposit = 'Deposit',
  Fees = 'Fees',
  MigrationFundsIn = 'MigrationFundsIn',
  MigrationFundsOut = 'MigrationFundsOut',
  Refund = 'Refund',
  Tax = 'Tax',
  TransferIn = 'TransferIn',
  TransferOut = 'TransferOut',
  Unknown = 'Unknown',
  Withdrawal = 'Withdrawal'
}
